/* eslint-disable */

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

import vuetify from './plugins/vuetify'

import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'bootstrap/dist/js/bootstrap.min.js'
import "popper.js/dist/popper.min.js"



Vue.config.productionTip = false
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)

// Vue.use(VueAxios, axios);
// new Vue({
//   render: h => h(App),
// }).$mount('#app')

// createApp(App).mount('#app')

new Vue({
  vuetify,
  router,
  // store,
  render: h => h(App),
}).$mount('#app')
